module.exports = __webpack_public_path__ + "static/media/cheryl-cole-icon.1fb7d40d.jpg";